// extracted by mini-css-extract-plugin
export var headerSearch = "SearchExpand-module--headerSearch--lXpet";
export var headerSearchForm = "SearchExpand-module--headerSearchForm--rLkNn";
export var headerSearchFormExpanded = "SearchExpand-module--headerSearchFormExpanded--QAzET";
export var searchButton = "SearchExpand-module--searchButton--HMCve";